var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "dropzoneElement",
      staticClass: "dropzone",
      class: { active: _setup.isDragging },
    },
    [
      _c("div", { staticClass: "d-flex align-items-start" }, [
        _setup.thumbnailSrc
          ? _c("div", { staticClass: "me-3" }, [
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _setup.showLightbox.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("img", {
                    class: { "form-field-image-img-progress": _setup.progress },
                    attrs: {
                      alt: _setup.fileData.fileName,
                      src: _setup.thumbnailSrc,
                    },
                  }),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "media-body" }, [
          _c(
            "div",
            [
              _setup.fileData.fileName
                ? _c(_setup.FormControlPlainText, {
                    attrs: {
                      value: _setup.fileData.fileName,
                      "form-id": _vm.formId,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticClass: "d-none",
                attrs: { accept: _setup.inputAccept, type: "file" },
                on: { change: _setup.onChangeFileInput },
              }),
              _vm._v(" "),
              _setup.showUploadOptions
                ? _c("div", [
                    _vm.tableName === _setup.filesTableName
                      ? _c("span", [_vm._v("Drag file here or")])
                      : _c("span", [_vm._v("Drag file here,")]),
                    _vm._v(" "),
                    _vm.tableName !== _setup.filesTableName
                      ? _c("span", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-light btn-sm",
                              attrs: { type: "button" },
                              on: { click: _setup.openImageBrowser },
                            },
                            [
                              _vm._v(
                                "\n                            Browse\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(" or ")]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-light btn-sm wizard-form-field-file-choose-file",
                        attrs: { type: "button" },
                        on: { click: _setup.chooseFile },
                      },
                      [
                        _vm._v(
                          "\n                        Upload\n                    "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _setup.progress
                ? _c(
                    "div",
                    {
                      staticClass: "progress mt-2 mb-1",
                      staticStyle: { height: "5px" },
                    },
                    [
                      _c("div", {
                        staticClass: "progress-bar",
                        style: { width: _setup.progress + "%" },
                        attrs: { role: "progressbar" },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.fileData.id && !_vm.readonly
                ? _c(
                    "div",
                    { staticClass: "d-flex align-items-center mt-3" },
                    [
                      _vm.tableName !== _setup.filesTableName
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-light btn-sm",
                              attrs: { type: "button" },
                              on: { click: _setup.openImageBrowser },
                            },
                            [
                              _vm._v(
                                "\n                        Browse\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.removeOption
                        ? [
                            _c("span", { staticClass: "ms-2" }, [_vm._v("or")]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-light btn-sm ms-2",
                                attrs: { type: "button" },
                                on: { click: _setup.removeFile },
                              },
                              [
                                _vm._v(
                                  "\n                            Remove\n                        "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }